import ScrollMagic from "scrollmagic";

jQuery(document).ready(function($) {
  const activeClass = "pack-active";

  // function showCurrentPack(active, current) {
  //   $(active).animate({ opacity: 0 }, () => {
  //     $(active).removeClass(activeClass);
  //     $(current).addClass(activeClass);
  //     $(current).animate({
  //       opacity: 1,
  //     });
  //   });
  // }

  function showCurrentPack(active, current) {
    let i = 0;
    i++;

    $(".presentation-category__img-wrapper > div")
      .animate(
        { opacity: 0 },
        {
          queue: false,
        }
      )
      .promise()
      .done(() => {
        $(".presentation-category__img-wrapper > div").removeClass(activeClass);
        $(current).addClass(activeClass);
        $(current).animate({
          opacity: 1,
        });
      });
  }

  jQuery(`ul[data-attribute_name="attribute_pa_pacco"] li`).on(
    "click",
    function(e) {
      const { currentTarget } = e;

      const value = $(currentTarget).data("value"),
        activePack = document.querySelector(`.${activeClass}`),
        currentPack = document.querySelector(`.pack-${value}`);

      if (!value) return;

      if (activePack === currentPack) return;

      showCurrentPack(activePack, currentPack);
    }
  );

  jQuery(".reset_variations").on("click", () => {
    const packDefault = document.querySelector(".pack-default"),
      activePack = document.querySelector(`.${activeClass}`);

    if (packDefault === activePack) return;

    showCurrentPack(activePack, packDefault);
  });

  // /** Questo cambia solamente quando cambia immagine slider woocommerce */
  // jQuery(document.body).bind("found_variation", (e, variation) => {
  //   const value = $("#pa_pacco").val(),
  //     activePack = document.querySelector(`.${activeClass}`),
  //     currentPack = document.querySelector(`.pack-${value}`);

  //   if (!value) return;

  //   if (activePack === currentPack) return;

  //   showCurrentPack(activePack, currentPack);
  // });

  /** Questo cambia solamente quando vengono resettate le variazioni su woocommerce */
  // jQuery(document.body).bind("reset_data", () => {
  //   console.log("before");
  //   const packDefault = document.querySelector(".pack-default"),
  //     activePack = document.querySelector(`.${activeClass}`);

  //   if (packDefault === activePack) return;

  //   showCurrentPack(activePack, packDefault);
  // });

  // Questo cambia appena selezioni un pacco,senza selezionare tutte le varianti e quando si clicca su svuota
  // $('[data-attribute_name="attribute_pa_pacco"]').on("change", (e) => {
  //   const {
  //       currentTarget: { value },
  //     } = e,
  //     activePack = document.querySelector(`.${activeClass}`),
  //     currentPack = document.querySelector(`.pack-${value}`),
  //     packDefault = document.querySelector(".pack-default"),
  //     pack = value ? currentPack : packDefault;

  //   if (activePack && activePack === pack) return;

  //   // If we have no value reset image to their default if not already set
  //   showCurrentPack(activePack, pack);
  // });

  // Underline title
  const controller = new ScrollMagic.Controller();

  const scene = new ScrollMagic.Scene({
    triggerElement: ".presentation-category",
    // duration: 100, // the scene should last for a scroll distance of 100px
    offset: 50, // start this scene after scrolling for 50px
  }).addTo(controller); // assign the scene to the contro

  // scene.addIndicators();

  scene.on("enter", () => {
    $(".presentation-category").addClass("presentation-category-active");
  });
});
